export default __webpack_public_path__ + "64291f4fb7b70bbb92eff47785161a13.png";